export type AdminNavigationItem = {
  key: 'users' | 'error-reports' | 'sign-in-access';
  label: string;
  path: '/admin' | '/admin/error-reports' | '/admin/sign-in-access';
};

export function getAdminNavigation(
  canImpersonate: boolean,
  canManageErrorReports: boolean,
  canManageSignInAccess: boolean,
): AdminNavigationItem[] {
  const items: AdminNavigationItem[] = [];

  if (canImpersonate) {
    items.push({ key: 'users', label: 'Users', path: '/admin' });
  }

  if (canManageErrorReports) {
    items.push({
      key: 'error-reports',
      label: 'Error Reports',
      path: '/admin/error-reports',
    });
  }

  if (canManageSignInAccess) {
    items.push({
      key: 'sign-in-access',
      label: 'Sign-in Access',
      path: '/admin/sign-in-access',
    });
  }

  return items;
}

export function getSidebarSelectedValue(path: string): string {
  if (path === '/overview') return 'home';
  if (path === '/settings') return 'settings';
  if (path === '/admin' || path.startsWith('/admin/')) return 'admin';
  if (path === '/data-models' || path.startsWith('/data-models/')) return 'data-models';
  if (
    path === '/data-sources'
    || path.startsWith('/data-sources/')
    || path.startsWith('/connections/')
    || path === '/connectors'
  ) return 'data-sources';
  if (path === '/dashboards' || path.startsWith('/dashboards/')) return 'dashboards';
  if (path === '/shared-dashboards' || path.startsWith('/shared-dashboards/')) return 'shared-dashboards';
  return '';
}

export function canRaiseTestException(isAdmin: boolean, isImpersonating: boolean): boolean {
  return isAdmin && !isImpersonating;
}